/* The favorite star in the top bar: a 32px ghost icon button, the left sidebar Favorites' glyph. */
button.star {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  flex-shrink: 0;
}

button.star:hover {
  background-color: var(--tuna-palette-action-hover);
  color: var(--tuna-content-primary);
}

/* Filled carries the state; the warning colour (the text-safe one, 3:1 on light surfaces) marks it too */
button.star[aria-pressed='true'] {
  color: var(--tuna-feedback-warning-text);
}

button.star svg {
  width: 18px;
  height: 18px;
}

@media (pointer: coarse) {
  button.star {
    width: 44px;
    height: 44px;
  }
}
